<template>
  <AppWithLoading v-slot:default="{loader}">
    <div class="article-row row">
      <div class="col-3 col-sm-2">
        <span class="article-row__date">{{ createdAt }}</span>
      </div>
      <div class="col-6 col-sm-8">
        <router-link :to="articleLinkParams" class="article-row__title">
          {{ article.title === null ? "Untitled" : article.title }}
        </router-link>
      </div>
      <div class="col-3 col-sm-2 col-right">
        <router-link :to="articleLinkParams" class="article-row__title">
          <VBtn small icon>
            <VIcon small>
              mdi-pencil
            </VIcon>
          </VBtn>
        </router-link>
        <VBtn small icon @click="loader(() => deleteArticle(article.id))">
          <VIcon small>
            mdi-delete
          </VIcon>
        </VBtn>
      </div>
    </div>
    <!-- <span>
      {{ article.author }}
    </span> -->
    <!-- <VImg :src="article.previewUrl" /> -->
  </AppWithLoading>
</template>
<script>
import { toRefs } from '@vue/composition-api';
import useArticle from '@/compositions/useArticle';
import AppWithLoading from '@/components/AppWithLoading';
import { format } from '../../date-utils';

export default {
  name: 'BlogArticle',
  components: { AppWithLoading },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { article } = toRefs(props);
    const { deleteArticle } = useArticle();
    const createdAt = format(new Date(article.value.createdAt), 'dd MMMM');
    const articleLinkParams = { name: 'article-edit', params: { id: article.value.$id } };

    return {
      articleLinkParams,
      deleteArticle,
      createdAt,
    };
  },
};
</script>

<style scoped lang="scss">
.article-row {
  padding: 4px 0;
  border-bottom: 1px solid rgba(#212121, 0.1);

  &__date {
    font-size: 12px;
    line-height: 20px;
    color: #757575;
    font-weight: 500;
  }

  &__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #0A82D9;
    text-decoration: none;
    transition: opacity 0.25s;

    &:hover {
      opacity: 0.75;
    }
  }
}

.col-right {
  text-align: right;
}
</style>

<i18n lang="yml" locale="en">
edit: Edit
delete: Delete
</i18n>

<i18n lang="yml" locale="ru">
edit: Редактировать
delete: Удалить
</i18n>
